import * as signalR from "@microsoft/signalr";
import url from "@/services/Url";
import store from "@/store";
import router from "@/router/index";
import { useToast } from "vue-toastification";
const toast = useToast();
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import ToastNotificationTicket from "@/components/custom-toast/ToastNotificationTicket.vue";
import $bus from "@/utils/event.js";
import { ref } from "vue";

const mensagemCarregamento = ref({});

export const hubConnection = {
  connection: null,
  start() {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(url + "/appHubPath")
      .build();

    setTimeout(() => {
      this.connect();
    }, 1000);
  },

  connect() {
    this.connection.start().then(
      async () => {
        // console.log(
        //   "Conectado ao hub SignalR: " + this.connection.connectionId
        // );

        await this.validarSessaoUsuario();

        this.connection.on("DesconectarSessao", () => {
          //console.log("DesconectarSessao: " + this.connection.connectionId);
          this.logoutSessao();
        });

        this.connection.on("DesconectarConnection", () => {
          //console.log("DesconectarConnection: " + this.connection.connectionId);
          this.logoutConnection();
        });

        this.connection.on("NotificacaoTicket", (id_ticket) => {
          //console.log("NotificacaoTicket: " + id_ticket);
          this.exibirNotificacaoTicket(id_ticket);
        });

        this.connection.on("CarregamentoDados", (mensagem) => {
          mensagemCarregamento.value = mensagem;
        });
      },
      () => {
        setTimeout(() => {
          this.connect();
        }, 60000);
      }
    );

    this.connection.onclose(() => {
      this.connect();
    });
  },

  async validarSessaoUsuario() {
    if (localStorage.getItem("user")) {
      let user = JSON.parse(localStorage.getItem("user"));
      try {
        let ret = await this.connection.invoke(
          "ConectarUsuario",
          user.RefreshToken,
          user.User.id
        );
        if (ret.success === true) {
          if (
            router &&
            router.currentRoute &&
            router.currentRoute._value &&
            router.currentRoute._value.name &&
            router.currentRoute._value.name.includes("sign-in")
          ) {
            router.push({ name: "dashboard" });
          }
        } else {
          await Swal.fire({
            text: ret.message,
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "Sair",
            customClass: {
              confirmButton: "btn fw-bold btn-warning",
            },
          });
          this.logoutConnection();
        }
      } catch (error) {
        console.log(error);
        await Swal.fire({
          text: error.message,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Sair",
          customClass: {
            confirmButton: "btn fw-bold btn-warning",
          },
        });
        this.logoutConnection();
      }
    } else {
      router.push({ name: "sign-in" });
    }
  },

  logoutSessao() {
    store.dispatch("auth/logout").then(() => {
      router.push({ name: "sign-in" });
      toast.info("Sessão expirada, por favor faça login novamente!", {
        timeout: 3000,
      });
    });
  },

  logoutConnection() {
    router.push({ name: "sign-in" });
    toast.info("Sessão expirada, por favor faça login novamente!", {
      timeout: 3000,
    });
  },

  exibirNotificacaoTicket(id_ticket) {
    toast.info(
      {
        component: ToastNotificationTicket,
        listeners: {
          abrirTicket: () => {
            if (
              router &&
              router.currentRoute &&
              router.currentRoute._value &&
              router.currentRoute._value.path &&
              router.currentRoute._value.path.includes(
                "/suporte/ticket/editar/" + id_ticket.toString()
              )
            ) {
              $bus.trigger("atualizar-ticket");
            } else {
              router.push({
                path: "/suporte/ticket/editar/" + id_ticket.toString(),
              });
            }
          },
        },
      },
      {
        timeout: false,
      }
    );
  },
};

export { mensagemCarregamento };
export default hubConnection;
